/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2021, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 *
 * @class APISpec
 * @hideconstructor
 * @classdesc
 */
define(['underscore'], (_) => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				const renderContextInfo = ['id', 'refresh', 'refreshAll', 'resizing', 'sameQueryData', 'taskRefreshed', 'extraInfo'];
				const getInfoFn = (args) => {
					return {
						renderContext: _.pick(args[0].renderContext, ...renderContextInfo)
					};
				};
				this.apiSpec = {
					name: 'Render Sequence',
					events: {
						actions: {
							startTaskExecution: {
								type: 'execution',
								getEventName: (args) => {
									const taskId = args[0].task.id;
									return taskId ? `start:${taskId}` : 'start';
								},
								getAction: () => [],
								getInfo: getInfoFn,
								getUndoActions: () => []
							},
							resolveTaskExecution: {
								type: 'execution',
								getEventName: (args) => {
									const taskId = args[0].task.id;
									return taskId ? `end:${taskId}` : 'end';
								},
								getAction: () => [],
								getInfo: getInfoFn,
								getUndoActions: () => []
							},
							rejectTaskExecution: {
								type: 'execution',
								getEventName: (args) => {
									const taskId = args[0].task.id;
									return taskId ? `fail:${taskId}` : 'fail';
								},
								getAction: () => [],
								getInfo: getInfoFn,
								getUndoActions: () => []
							}
						}
					}
				};
			}
			return this.apiSpec;
		}
	}
	return APISpec;
});
